import { matchPath } from 'react-router'

const matches = [
  '/tickets/:originCanonical/:destinationCanonical',
  '/:languageCode/tickets/:originCanonical/:destinationCanonical',
]

export function getInitialUrlParams() {
  const location = window.location

  // react-router v6 removed the abiulity to have optional path parameters
  // languageCode (and both canonicals) are optional in our URL scheme, so
  // we have to hand-craft individual matches above to pull out URL parameters
  // for any expected URL. The order matters (in case originCanonical is 'map')

  var path = ''
  var match = null
  var i = 0
  for (i = 0; i < matches.length; i++) {
    path = matches[i]
    match = matchPath(location.pathname, path)
    if (match) return match.params
  }

  return {}
}
